    <div *ngIf="pEntity" class="result pointer list-group-item list-group-item-action d-flex">
            <div class="d-flex align-items-start justify-content-center">
                <div style="width: 3rem; height: 3rem; border-radius: 2rem; background: #595959"
                ></div>
            </div>
            <div class="ms-3" (click)="goToEntity(pEntity)">
                <div class="small text-muted">
                    <span>{{ owner.display_name }}</span>
                    <span class="ms-1 coord">
                        [{{ pEntity.coord.x | number:"1.0-0" }}:{{ pEntity.coord.y | number:"1.0-0" }}]
                    </span>
                    <span class="ms-1">{{ pEntity.createdString }}</span>
                </div>
                <div class="">
                    {{ pEntity.componentProperties.Text.slice(0,100) }}
                </div>
            </div>
    </div>
